const BASE_URL = "https://app.rankspro.io/api";
const API_URL = `${BASE_URL}/user`;

export const GET_USER_PROJECT = (email) =>
  `${API_URL}/adminprojectget/?email=${encodeURIComponent(email)}`;

// refresh data
export const GET_SITEOVERVIEW_REFRESH = () => `${API_URL}/admindomainoverview/`;
export const GET_BACKLINK_REFRESH = () => `${API_URL}/adminbacklinks/`;

export const POST_DOMAIN_KEYWORD = (config) =>
  `${API_URL}/domainkeyword/?domain_name=${config.domain_name}&location_code=${config?.location_code}&language_code=en&location_name=${config.location_name}&language_name=${config.language_name}`;

export const POST_DOMAIN_OVERVIEW = (config) =>
  `${API_URL}/domainoverview/?domain_name=${config.domain_name}&location_code=${config?.location_code}&language_code=en&location_name=${config.location_name}&language_name=${config.language_name}`;

// guest post link
export const GET_ALLLINKFEATURE_API = () =>
  `https://app.rankspro.io/api/user/userlinkallget/`;

export const PUT_LINKUPDATE = () =>
  `https://app.rankspro.io/api/user/linkupdate/`;

// get user cancel plan
export const GET_CANCELPLAN = () =>
  `https://app.rankspro.io/api/user/getcancelsubs/`;

//services
export const GET_ALLSERVICES = () =>
  `https://app.rankspro.io/api/user/userservicesget/`;

export const POST_SERVICES = () =>
  `https://app.rankspro.io/api/user/userservices/`;

export const PUT_SERVICES = (id) =>
  `https://app.rankspro.io/api/user/updateuserservices/${id}/`;

// resume rank-tracking
export const GET_RESUMERANKTRACKING = (email) =>
  `https://app.rankspro.io/api/user/resumerank/?email=${email}`;
